import React from "react";
import * as styles from "../style";

// Smartphone frame the composer grid is rendered inside.
const PhoneMockup = ({ children }) => (
  <styles.PhoneFrame>
    <styles.Notch />
    <styles.PhoneScreen>{children}</styles.PhoneScreen>
  </styles.PhoneFrame>
);

export default PhoneMockup;
